import React, { Component} from "react";
import Select from "react-select";
import "react-select/dist/react-select.css";
import Proptypes from "prop-types";

class SelectInput extends Component {
    onChange(event) {
        if (this.props.input.onChange && event != null) {
            if(this.props.multi) {
                this.props.input.onChange(event.map(item => item.value))
            } else {
                this.props.input.onChange(event.value);
            }
        } else {
            this.props.input.onChange(null);
        }
    }
 
    render() {
        return (
            <React.Fragment>
                {this.props.isUpdateForm ?
                    <Select {...this.props }
                        value = { this.props.selectedValue || [] }
                        onBlur = {() => this.props.input.onBlur(this.props.input.value) }
                        onChange = { this.onChange.bind(this) }
                        valueRenderer={this.props.renderValue}
                        optionRenderer={this.props.renderOption}
                        options={this.props.options}
                    /> : 
                    <Select.Creatable {...this.props }
                        value = { this.props.selectedValue || "" }
                        onBlur = {() => this.props.input.onBlur(this.props.input.value) }
                        onChange = { this.onChange.bind(this) }
                        valueRenderer={this.props.renderValue}
                        optionRenderer={this.props.renderOption}
                        options={this.props.options}
                    />}
            </React.Fragment>
        );
    }
}

SelectInput.propTypes = {
    input: Proptypes.object,
    options: Proptypes.array,
    isUpdateForm: Proptypes.bool,
    selectedValue: Proptypes.oneOfType([
        Proptypes.string,
        Proptypes.arrayOf(Proptypes.string),
    ]),
    renderValue: Proptypes.func,
    renderOption: Proptypes.func,
    history: Proptypes.object,
};
 
export default SelectInput;